shared-raw
  script(type="typescript").
    this.on('mount', ()=>{ this.onMount() })
    this.onMount = function(){
      let rootElement = <HTMLElement>this.root;
      rootElement.innerHTML = this.opts.content;
    }
